import { memo } from 'react';
import { RolesModel } from '../../models/Roles';
import { DropdownActions } from '../interaction/DropdownActions';

interface RoleListRowProps {
  role: RolesModel;
  isLast: boolean;
  showActions: boolean;
  onEdit: (role: RolesModel) => void;
  onDelete: (role: RolesModel) => void;
}

export const RoleListRow = memo(function RoleListRow({
  role,
  isLast,
  showActions,
  onEdit,
  onDelete,
}: RoleListRowProps) {
  return (
    <div
      className={`grid grid-cols-[1fr_auto_2.5rem] items-center gap-3 px-4 py-3.5 sm:py-4 ${
        isLast ? '' : 'border-b border-border'
      }`}
      data-testid={`role-row-${role.id}`}
    >
      <p className="min-w-0 truncate pr-1 text-sm font-medium text-foreground">{role.name}</p>

      <span className="max-w-[6rem] shrink-0 rounded-full border border-border bg-muted/40 px-2.5 py-1 text-center text-xs font-medium text-foreground sm:max-w-[7rem]">
        {role.permissions?.length ?? 0}
      </span>

      <div className="flex justify-end">
        {showActions ? <DropdownActions onEdit={() => onEdit(role)} onDelete={() => onDelete(role)} /> : null}
      </div>
    </div>
  );
});
